module.exports = __webpack_public_path__ + "img/Support-skill-235.c98f4625.png";